import { HttpClient } from './http-client';

export interface OtpwAssignment {
    otpwAssignmentId: string;
    correlationId: string;
    vin: string;
    expiresAt: string;
    createdTimestamp: string;
    createdAccountId: string;
    lastUpdatedTimestamp: string;
    lastUpdatedAccountId: string;
    otpw: string;
}

export class OtpwService {
    constructor(private http: HttpClient) {}

    fetchOtpwAssignment(otpwAssignmentId: string, signal?: AbortSignal, ignoreCache = true) {
        return this.http.orchestrateRequest<OtpwAssignment>({
            method: 'GET',
            url: `/otpw-assignment/${otpwAssignmentId}`,
            ignoreCache,
            signal,
        });
    }
}
